import { PoolTokenType } from "impermax-sdk";
import React, { createContext } from "react";

const PoolTokenContext = createContext<PoolTokenType>(null);
export default PoolTokenContext;
